import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"mobile","breakpoints":{"mobileXs":595,"mobile":768,"tablet":1024,"laptop":1280,"desktop":1600,"desktopLg":1920}})
